import { Entity } from '@backstage/catalog-model';

/**
 * The API entity annotation that opts it into per-environment definitions: an
 * S3 URL with one `{env}` placeholder, under which each environment's pipeline
 * uploads its definition, e.g.
 * `https://temabit-backstage-apidoc-bucket.s3.eu-central-1.amazonaws.com/lfoz/Profile/{env}-openapi.json`.
 *
 * Mirrored in the backend plugin, which validates it.
 */
export const API_DEFINITION_URL_TEMPLATE_ANNOTATION =
  'temabit.com/api-definition-url-template';

/** Whether the API page should show the per-environment definition card. */
export function isApiDefinitionEnvironmentsAvailable(entity: Entity): boolean {
  return Boolean(
    entity.metadata.annotations?.[API_DEFINITION_URL_TEMPLATE_ANNOTATION],
  );
}
